namespace app.toolbar {
    'use strict';

    import IScope = angular.IScope;
    import IDialogService = ng.material.IDialogService;
    import IStateService = angular.ui.IStateService;
    import ISidenavService = angular.material.ISidenavService;
    import IMedia = angular.material.IMedia;
    import IAugmentedJQuery = angular.IAugmentedJQuery;
    import AuthService = app.autenticacao.AuthService;
    import InformacaoService = app.toolbar.InformacaoService;
    import GestaoContaService = app.toolbar.GestaoContaService;
    import CommandService = app.support.command.CommandService;
    import IConta = app.autenticacao.IConta;
    import INotification = app.notification.INotification;

    export class ToolbarController {

        private folded: boolean;
        private bodyEl: IAugmentedJQuery;
        public userStatus;
        public nome: string;
        public login: string;
        public lotacao: string;
        public unreadFeed: number = 0;
        public searchBar: boolean = false;
        public configuracoes: any[] = [];
        public mainAccount: IConta;
        public secondaryAccounts: IConta[] = [];
        public accounts: IConta[] = [];

        /** @ngInject **/
        constructor($scope: IScope, private $state: IStateService, private $mdSidenav: ISidenavService,
            private $window: ng.IWindowService, private $mdMedia: IMedia, private $rootScope: ng.IRootScopeService,
            private $mdDialog: IDialogService,
            private msNavigationService, private authService: AuthService, private $q: ng.IQService,
            private informacaoService: InformacaoService, private messagesService: app.support.messaging.MessagesService,
            private commandService: CommandService, private properties: app.support.constants.Properties,
            private toolbarService: ToolbarService, private gestaoContaService: GestaoContaService) {

            this.bodyEl = angular.element('body');

            $scope.$watch(() => {
                return $mdMedia('gt-sm');
            }, () => this.updateNavigation());

            this.authService.getUser().then((user) => {
                this.nome = user.nome;
                this.login = user.login;
                this.lotacao = user.lotacao;
                this.accounts = user.contas;
                this.mainAccount = user.contas.find((c: any) => { return user.lotacao === c.codigo });
                this.secondaryAccounts = user.contas.filter((c: any) => { return user.lotacao !== c.codigo });
                this.orderSecondaryAccounts();
            });

            this.folded = true;

            $scope.$on("feed", () => {
                this.unreadFeed += 1;
            });

            $scope.$on("feed:unread", (event: ng.IAngularEvent, unreadFeed: number) => {
                this.unreadFeed = unreadFeed;
            });

            $scope.$on("integracoes-identidades:conta-atual-alterada", 
                (event: ng.IAngularEvent, notification: INotification) => {
                let novaLotacao: string = notification.content;

                if (this.lotacao !== novaLotacao) {
                    this.authService.clearCache();
                    this.$window.location.reload();
                }
            });

            // Verificando se o usuário logado possui permissão para consultar informações judiciais
            this.commandService.findByIdAndContext("pesquisar-informacoes", "integracoes-processos").then(() => {
                this.searchBar = true;
            });

            $scope.$on("navigationToggledFolded", () => {
                this.updateNavigation();
            });

            $scope.$watch(() => {
                return this.toolbarService.getConfigurations().length;
            }, (length) => {
                if (length) {
                    this.configuracoes = [];
                    for (let configuration of this.toolbarService.getConfigurations()) {
                        this.configuracoes.unshift(configuration);
                    }
                }
            });
        }

        public changeAccount(event, conta) {
            this.$mdDialog.show({
                clickOutsideToClose: true,
                controller: 'app.toolbar.AlterarContaController',
                locals: {
                    setorId: conta.codigo
                },
                controllerAs: 'vm',
                templateUrl: 'app/main/toolbar/modals/alterar-conta/alterar-conta.html',
                parent: angular.element(document.body),
                targetEvent: event
            }).then(() => this.alterarContaAtual(conta));
        }

        private alterarContaAtual(conta: IConta) {
            this.definirContaComoAtual(conta);
            this.mainAccount = this.accounts.find(c => this.lotacao === c.codigo);
            this.secondaryAccounts = this.accounts.filter(c => this.lotacao !== c.codigo);
            this.orderSecondaryAccounts();
        }

        private orderSecondaryAccounts(): void {
            this.secondaryAccounts.sort((a, b) => (a.nome < b.nome) ? -1 : 1);
        } 

        public definirContaComoAtual(conta: IConta): void {
            this.accounts = this.accounts.map(obj => {
                if (obj.codigo === conta.codigo) {
                    return { ...obj, atual: true };
                }
                return { ...obj, atual: false };
            });
        }

        public toggleNavigation() {
            if (this.$mdMedia('gt-sm')) {
                this.msNavigationService.toggleFolded();
            } else {
                this.toggleSidenav('navigation');
            }
            this.updateNavigation();
        }

        public getFolded() {
            if (this.folded === null) {
                return true;
            }
            return this.folded;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        public toggleSidenav(sidenavId) {
            this.$mdSidenav(sidenavId).toggle()
                .then(() => {
                    if (this.unreadFeed) {
                        this.$rootScope.$broadcast('feed:readed');
                    }
                    this.unreadFeed = 0
                });
        }

        public hasPermission() {
            return this.searchBar;
        }

        /**
         * Busca adaptada para encontrar informações processuais
         *
         * <p>Originalmente, era usada pelo template para buscar funcionalidades
         *
         * @param query a identificação da informação
         * @returns {Promise}
         */
        public search(query) {
            var navigation = [];

            var deferred = this.$q.defer();

            this.informacaoService.informacoes(query).then(informacoes => {

                if (query.length !== 0) {

                    for (let informacao of informacoes) {
                        navigation.push({
                            title: informacao.descricao,
                            description: informacao.tipoDeIdentificacao,
                            icon: informacao.icon,
                            state: informacao.state,
                            id: informacao.identificacao.replace('/', '-'),
                            url: informacao.url
                        });
                    }

                } else {
                    navigation = null;
                }

                deferred.resolve(navigation);

            }, (error: any) => {
                deferred.reject(error.status);
                switch (error.status) {
                    case 404: {
                        this.messagesService.error("Serviço de consulta temporariamente indisponível.");
                        break;
                    }
                    case 408: {
                        this.messagesService.warn("A consulta para o termo [" + query + "] está demorando mais do que o permitido, provavelmente devido ao excesso de resultados. Por favor, refine o termo pesquisado.", 12000);
                        break;
                    }
                    case 413: {
                        this.messagesService.warn("A consulta para o termo [" + query + "] encontrou mais registros do que o permitido para essa funcionalidade. Por favor, refine os termos de sua consulta ou acesse a pesquisa avançada disponível no Pesquisa Acervo Processual.", 12000);
                        break;
                    }
                    default: {
                        this.messagesService.error("Ocorreu um erro inesperado. Por favor, entre em contato com a STI para reportar o incidente.");
                        break;
                    }
                }
            });

            return deferred.promise;
        }

        /**
         * Recupera a consultas registradas recentemente.
         *
         * @returns a lista de consultas recentes
         */
        public searchRecents() {
            let recents = [];

            for (let informacao of this.informacaoService.getHistorico()) {
                if (informacao.tipo === "processo") {
                    recents.push({
                        title: "Processo " + informacao.descricao,
                        description: "Número",
                        icon: "icon-folder-multiple",
                        state: "app.informacoes.processos",
                        id: informacao.identificacao,
                        url: "informacoes/processos/:id"
                    });
                }

                if (informacao.tipo === "peticao") {
                    recents.push({
                        title: "Petição " + informacao.descricao,
                        description: "Número e Ano",
                        icon: "icon-file-document",
                        state: "app.informacoes.peticoes",
                        id: informacao.identificacao,
                        url: "informacoes/peticoes/:id"
                    });
                }

                if (informacao.tipo === "protocolo") {
                    recents.push({
                        title: "Protocolo " + informacao.descricao,
                        description: "Número e Ano",
                        icon: "icon-file-document",
                        state: "app.informacoes.protocolos",
                        id: informacao.identificacao,
                        url: "informacoes/protocolos/:id"
                    });
                }
            }

            return recents;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        public searchResultClick(item) {
            if (!!item) {
                this.$state.go(item.state, { 'id': item.id });
            }
        }

        /**
         * Sets User Status
         * @param status
         */
        public setUserStatus(status) {
            this.userStatus = status;
        }

        /**
         * Logout Function
         */
        public logout() {
            this.authService.logout().then(() => {
                this.$state.go('app.login');
            });
        }
        
        /**
         * Logout Function
         */
        public logoutAll() {
            this.authService.logoutAll().then(() => {
                this.$state.go('app.login');
            });
        }        

        /**
         * Toggle horizontal mobile menu
         */
        public toggleHorizontalMobileMenu() {
            this.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        private updateNavigation() {
            if (this.$mdMedia('gt-sm')) {
                this.folded = this.msNavigationService.getFolded();
            } else {
                this.folded = this.$mdSidenav('navigation').isOpen();
            }
        }

        public openDocs() {
            window.open(`${this.properties.apiUrl}/integracoes-documentacao/index.html`, '_blank');
        }

        public openProfile() {
            this.$state.go("app.configuracoes.gerenciar-usuarios.perfil");
        }

    }

    angular
        .module('app.toolbar')
        .controller('app.ToolbarController', ToolbarController);
}